import Color from "color";
import type { GroupBase, StylesConfig } from "react-select";
import type { BaseOption } from "./useFormatOptionLabel";
import { radius, zIndex } from "../index";

const styles: StylesConfig<BaseOption, boolean, GroupBase<BaseOption>> = {
  menuPortal: styles => ({ ...styles, zIndex: zIndex.modalOverlay }),
  control: styles => ({
    ...styles,
    backgroundColor: "white",
    maxHeight: 100,
    overflowY: "auto",
    border: "1px solid #e0e3eb",
    borderRadius: radius,
    boxShadow: "none",
    font: '400 14px "Open Sans"',
    minHeight: "40px",
  }),
  valueContainer: (styles, { isMulti }) => ({
    ...styles,
    padding: isMulti ? 4 : "0 12px",
  }),
  indicatorsContainer: styles => ({ ...styles, marginRight: 8 }),
  clearIndicator: styles => ({ ...styles, padding: 0 }),
  dropdownIndicator: styles => ({ ...styles, padding: 0 }),
  loadingIndicator: styles => ({ ...styles, padding: 0 }),
  option: (styles, { isDisabled, isFocused }) => {
    const disabledColor = "titanium200";
    const focusedColor = Color("#2C2C2C").alpha(0.1).string();
    const color = isDisabled ? disabledColor : "#000";
    const backgroundColor = isDisabled ? undefined : isFocused ? focusedColor : undefined;

    return {
      ...styles,
      position: "relative",
      zIndex: 9999,
      padding: 0,
      color,
      backgroundColor,
      ":active": {
        backgroundColor,
      },
    };
  },
  input: (styles, { isMulti }) => ({
    ...styles,
    margin: 0,
    padding: 0,
    paddingLeft: isMulti ? 8 : 0,
  }),
  placeholder: (styles, { isMulti }) => ({
    ...styles,
    margin: 0,
    color: "#b5b5b5",
    paddingLeft: isMulti ? 8 : 0,
  }),
  singleValue: (styles, { data }) => (data.color ? { ...styles } : styles),
  multiValue: (styles, { data, isFocused }) => {
    const color = Color(data.color ?? "#DDD");
    const contrastColor = color.isDark() ? "white" : "black";

    return {
      ...styles,
      color: contrastColor,
      backgroundColor: color.string(),
      border: `2px dashed ${isFocused ? contrastColor : "transparent"}`,
    };
  },
  multiValueLabel: styles => ({
    ...styles,
    fontWeight: "bold",
    color: "inherit",
    backgroundColor: "inherit",
  }),

  multiValueRemove: styles => ({
    ...styles,
    cursor: "pointer",
    color: "inherit",
    backgroundColor: "inherit",
    ":hover": {
      color: "inherit",
      backgroundColor: "inherit",
    },
    "& svg": {
      transition: "transform ease-in-out 100ms",
    },
    ":hover svg": {
      transform: "scale(1.2)",
    },
  }),
};

export default styles;
